import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useState } from "react";

const NAV_LINKS = [
  { label: "首页", to: "/" },
  { label: "影视作品", to: "/works" },
  { label: "明星动态", to: "/news" },
  { label: "关于", to: "/about" },
];

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const isHome = location.pathname === "/";
  const transparent = isHome && !scrolled;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const linkBase = "relative text-sm px-3 py-2 rounded-md transition-colors duration-200 whitespace-nowrap";
  const activeText = transparent ? "text-white" : "text-primary-700";
  const idleText = transparent
    ? "text-white/75 hover:text-white"
    : "text-foreground-600 hover:text-foreground-950";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        transparent
          ? "bg-transparent"
          : "bg-background-50/95 backdrop-blur border-b border-background-200/70"
      }`}
    >
      <nav className="flex items-center justify-between px-5 md:px-10 h-16 md:h-[72px]">
        <Link to="/" className="flex items-center gap-2.5 group">
          <span
            className={`flex items-center justify-center w-9 h-9 rounded-lg font-heading font-bold text-base transition-colors ${
              transparent ? "bg-white/15 text-white" : "bg-primary-500 text-background-50"
            }`}
          >
            爱
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading font-bold text-lg tracking-wide ${
                transparent ? "text-white" : "text-foreground-950"
              }`}
            >
              佐山爱
            </span>
            <span
              className={`text-[10px] tracking-[0.25em] uppercase ${
                transparent ? "text-white/60" : "text-foreground-400"
              }`}
            >
              SAYAMA AI
            </span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {NAV_LINKS.map((link) => {
            const active =
              link.to === "/"
                ? location.pathname === "/"
                : location.pathname.startsWith(link.to);
            return (
              <Link
                key={link.to}
                to={link.to}
                className={`${linkBase} ${active ? activeText : idleText}`}
              >
                {link.label}
                {active && (
                  <span
                    className={`absolute left-3 right-3 -bottom-0.5 h-0.5 rounded-full ${
                      transparent ? "bg-accent-400" : "bg-accent-500"
                    }`}
                  />
                )}
              </Link>
            );
          })}
          <Link
            to="/works"
            className="ml-3 inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-sm font-medium bg-accent-500 text-background-50 hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line text-base" />
            观看作品
          </Link>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen((prev) => !prev)}
          className={`md:hidden flex items-center justify-center w-10 h-10 rounded-md transition-colors cursor-pointer ${
            transparent ? "text-white hover:bg-white/10" : "text-foreground-900 hover:bg-background-100"
          }`}
        >
          <i className={`text-2xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`} />
        </button>
      </nav>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70 px-5 pb-4">
          <div className="flex flex-col gap-1 pt-2">
            {NAV_LINKS.map((link) => {
              const active =
                link.to === "/"
                  ? location.pathname === "/"
                  : location.pathname.startsWith(link.to);
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`flex items-center justify-between px-3 py-3 rounded-md text-sm transition-colors ${
                    active
                      ? "bg-primary-50 text-primary-700 font-medium"
                      : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  {link.label}
                  <i className="ri-arrow-right-s-line text-lg text-foreground-400" />
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </header>
  );
}